import styled from 'styled-components'

export const StartBot = styled.div`
  width:100%;
  height:100%;
  display:flex;
  gap:10px;
  flex-direction:column;
`

export const LogoSwapper = styled.div`
  display:flex;
  flex-direction:column;
  flex:1;
  border-radius: 10px;
  background-color: #fff;
  padding: 0.5rem;
  overflow-y: scroll;
  white-space: nowrap;
  // box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  &::-webkit-scrollbar {
    display: none; 
  }
.icon-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 14px;
  padding: 0 4px;
}
.pool-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
  @media (max-width: 768px) {
    min-height:200px;
  }
`